import React from 'react';
import { Link } from '@primer/react'

export default function Projects() {
  return (
    <div className="projects d-flex flex-justify-center">
      <ul className="d-flex flex-column pl-0 text-left">
        <li>
          <Link href="https://mayalopez.dev/Clouddit">Clouddit for reddit &gt;&gt;</Link>
            <br />
            <span>- Word cloud of reddit posts, harnessing D3.js module and reddit API</span>
        </li>
        <li>
          <Link href="https://github.com/mayamessinger/LinguisticDB">LinguisticDB &gt;&gt;</Link>
          <br />
          <span>- Web development project analyzing bodies of text, implemented with PostgreSQL, Node, and Vue.js</span>
        </li>
        <li>
          <Link href="https://hackduke.org">HackDuke &gt;&gt;</Link>
          <br />
          <span>- University hackathon logistics lead 2017-2018, mentor 2018-2019</span>
          <br />
          <span>- Ideate design conference <Link href="https://ideate.hackduke.org">website</Link> developer</span>
        </li>
      </ul>
    </div>
  )
}